import React, { useEffect, useState } from "react";
import { useIsReadOnlyManager } from "@/shared/readOnlyManager";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import TopbarProfile from "./TopbarProfile";
import {
  Container,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  Navbar,
} from "reactstrap";
import { readAssignedPositionPermissions, hasUserPermissions} from "@/services/program/budget";

// const DefaultBrand = `${process.env.PUBLIC_URL}/img/logo/logo_light.svg`;
const BUDGET = "Budget";
const CAN_ACCESS_BUDGET = "can_access_budget";

const LINKS = [
  { to: "/manager/home", text: "Dashboard" },
  { to: "/manager/program-settings", text: "Reward Events" },
  { to: "/manager/manage-and-reward", text: "Manage and Reward" },
  //{ to: "/manager/invite-participant", text: "Invite New Participant" },
  // { to: "/manager/referral", text: "Referral Administrator" },
  { to: "/manager/manage-account", text: "Billing" },
  { to: "/manager/team", text: "Team" },
  { to: "/manager/faqs", text: "FAQ" }
];

const ManagerTopbar = ({ template, organization, program, auth, rootProgram }) => {
  // console.log(template)
  const [isOpen, setOpen] = useState(false);
  const readOnly = useIsReadOnlyManager();
  const [menuItems, setMenuItems] = useState(LINKS);
  const toggleNavbar = () => {
    setOpen((prev) => !prev);
  };


  const onClickNavLink = () => {
    if (isOpen) {
      setOpen(false);
    }
  };
  useEffect( () => {
    //console.log(program);
    if( program?.id ) {
        let newItems = !program.is_pay_in_advance
            ? LINKS.filter(item => item.to !== "/manager/manage-account")
            : [...LINKS];
        if( program.enable_referrals )(
          newItems.push({ to: "/manager/referral_tools", text: "Referral Widget" })
        )
        if (program.program_managers_can_invite_participants && !readOnly) {
            if (program.allow_award_new_participant) {
                // Only show combined "Invite and Award"
                newItems.splice(4, 0, {
                to: "/manager/award-new-participant",
                text: "Invite and Award New Participant"
                });
            } else {
                // Only show plain invite
                newItems.splice(4, 0, {
                to: "/manager/invite-participant",
                text: "Invite User"
                });
            }
        }
        
        if (organization?.id && auth && rootProgram?.id) {
          let budgetItems = [...newItems];
          readAssignedPositionPermissions(
            organization?.id,
            rootProgram?.id,
            auth?.positionLevel?.id
          )
            .then((position) => {
              if (
                rootProgram?.use_budget_cascading &&
                position &&
                hasUserPermissions(position, BUDGET, CAN_ACCESS_BUDGET)
              ) {
                budgetItems.push({ to: "/manager/budget", text: "Budget" });
                setMenuItems(budgetItems);
              }
              else{
                setMenuItems(newItems);
              }
            })
            .catch((err) => console.log(err));
        }
    }
}, [organization, program, auth, readOnly])

  if (!template) return "loading";
  // if (!template) return t("loading");
  const Brand = `${process.env.REACT_APP_API_STORAGE_URL}/${template.small_logo}`;
  return (
    <div className="topbar topbar--manager">
      <Container fluid className="topbar__wrapper">
        <Navbar color="" expand="md" fixed="" light>
          <div className="navbar-top_row">
            <div className="navbar-brand-logowrap">
              <NavbarBrand tag="span">
                <NavLink to="/manager/home" className="navbar-brand">
                  <img src={Brand} alt="brand-logo" />
                </NavLink>
              </NavbarBrand>
            </div>
            <div className="topbar__right navbar-profilewrap">
              <Collapse isOpen={isOpen} navbar>
                <Nav className="horizontal" navbar>
                  {menuItems?.map((item, index) => {
                    return (
                      <NavLink key={index} onClick={onClickNavLink} to={item.to} className="link">
                        {item.text}
                      </NavLink>
                    );
                  })}
                </Nav>
              </Collapse>
              <div className="topbar__utilities">
                <TopbarProfile isManager={true} />
                <NavbarToggler onClick={toggleNavbar} />
              </div>
            </div>
          </div>
        </Navbar>
      </Container>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    template: state.template,
    organization:state.organization,
    program: state.program,
    auth:state.auth,
    rootProgram: state.rootProgram
  };
};

export default connect(mapStateToProps)(ManagerTopbar);
